import React from "react";
export const ConfirmationLoader = () => {
  return (
    <div className="loading-container ch-ml--auto ch-mr--auto">
      <div className="ch-width--12">
        <div className="loading-confirmation ch-mt--2 ch-skeleton ch-width--12" />
      </div>
    </div>
  );
};
